import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RunExperimentComponent } from '@components/run-experiment/run-experiment.component';

@NgModule({
    declarations: [RunExperimentComponent],
    exports: [RunExperimentComponent],
    imports: [MatButtonModule]
})
export class RunExperimentModule { }